export const isNonEmptyStr = (data: string): boolean => /\S/.test(data);
